"use strict";

var _classCallCheck = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var SVGAnimatedStringImpl =
/*#__PURE__*/
function () {
  function SVGAnimatedStringImpl(args, privateData) {
    _classCallCheck(this, SVGAnimatedStringImpl);

    this._element = privateData.element;
    this._attribute = privateData.attribute;
    this._attributeDeprecated = privateData.attributeDeprecated; // can be undefined

    this._initialValue = privateData.initialValue; // can be undefined
  }

  _createClass(SVGAnimatedStringImpl, [{
    key: "baseVal",
    get: function get() {
      if (!this._element.hasAttributeNS(null, this._attribute)) {
        if (this._attributeDeprecated !== undefined && this._element.hasAttributeNS(null, this._attributeDeprecated)) {
          return this._element.getAttributeNS(null, this._attributeDeprecated);
        } else if (this._initialValue !== undefined) {
          return this._initialValue;
        }

        return "";
      }

      return this._element.getAttributeNS(null, this._attribute);
    },
    set: function set(base) {
      if (!this._element.hasAttributeNS(null, this._attribute) && this._attributeDeprecated !== undefined && this._element.hasAttributeNS(null, this._attributeDeprecated)) {
        this._element.setAttributeNS(null, this._attributeDeprecated, base);
      } else {
        this._element.setAttributeNS(null, this._attribute, base);
      }
    }
  }, {
    key: "animVal",
    get: function get() {
      return this.baseVal;
    }
  }]);

  return SVGAnimatedStringImpl;
}();

exports.implementation = SVGAnimatedStringImpl;